module.exports = __webpack_public_path__ + "static/comp-77e1ea481d7bfbe0fb2f9cf31a6956d3.svg";